"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoPlayHtmlRangeInput = void 0;
var _HtmlRangeInput2 = require("./HtmlRangeInput");
var _core = require("@dragon/core");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Autplay html range input with play button, it does not change the store state instead store the number from the range internally.
 *
 */
var AutoPlayHtmlRangeInput = exports.AutoPlayHtmlRangeInput = /*#__PURE__*/function (_HtmlRangeInput) {
  function AutoPlayHtmlRangeInput(parent, hideButton) {
    var _this;
    _classCallCheck(this, AutoPlayHtmlRangeInput);
    var state = _core.CORE.getState();
    _this = _callSuper(this, AutoPlayHtmlRangeInput, [parent, 1, 100, state.config.autoPlayRoundsToPlay, null, function (e) {
      _core.CORE.dispatch({
        type: _core.SET_AUTO_PLAY_ROUNDS,
        payload: parseInt(e)
      });
    }]);
    _defineProperty(_this, "_value", void 0);
    _defineProperty(_this, "_button", void 0);
    _core.CORE.subscribe("config.autoPlayRoundsToPlay", function (e) {
      _this._valueNode.innerHTML = e;
      _this._value = e;
    });
    if (!hideButton) {
      _this._button = document.createElement("button");
      _this._button.className = "matBtn yellow";
      _this._button.innerHTML = _core.CORE.translate("playauto");
      _this._button.onclick = function () {
        _core.CORE.dispatch({
          type: _core.AUTO_PLAY,
          payload: _this._value
        });
        _core.CORE.dispatch({
          type: _core.DIALOG_EXIT
        });
      };
      _this._node.appendChild(_this._button);
    }
    _this._headerNode.innerHTML = _core.CORE.translate("autoplay");
    _this._node.className = "slidecontainer autoplay";
    return _this;
  }
  _inherits(AutoPlayHtmlRangeInput, _HtmlRangeInput);
  return _createClass(AutoPlayHtmlRangeInput);
}(_HtmlRangeInput2.HtmlRangeInput);
//# sourceMappingURL=AutoPlayHtmlRangeInput.js.map